import axios from 'axios';
const api = process.env.isApiserver
export const loadData = async (
    ipData,
    route,
    tab,
    setIsLoading,
    setInfoMessage,
    dispatch,
    set_entities,
    set_ip_details,
    set_tabnames,
    language,
    set_hostname) => {
    try {
        setIsLoading(true);
        setInfoMessage('')
        const res = await axios.post(`${api}/${route}`, { host: ipData })
        const { retcode, ip4, data } = res.data;
        if (retcode === -40) {
            setIsLoading(false);
            return setInfoMessage(`${ipData} Adress Not Found`)
        }
        if (retcode === -30 || retcode === -50) {
            setIsLoading(false);
            return setInfoMessage(`${ipData} Missing Parameter`)
        }
        if (retcode === -101) {
            setIsLoading(false);
            return setInfoMessage(`${ipData} not possible to resolve or invalid entry`)
        }
        if (retcode === -102) {
            setIsLoading(false);
            return setInfoMessage(`${ipData} invalid host parameter given, not an ip, not a valid hostname`)
        }
        // only for true, it gets email and adress data
        if (tab === "mm") {
            try {
                const respDns = await axios.post(`${api}/rdns`,
                    { host: ip4 });
                const { retcode, dns } = respDns.data;
                console.log(respDns.data)
                if (retcode === -50) dispatch(set_hostname("invalid ip for DNS", ip4));
                if (retcode === -1) dispatch(set_hostname(language === "Turkish" ? "Ters DNS Yok" : "No Reverse DNS", ip4));
                if (retcode === 200) dispatch(set_hostname(dns[0], ip4))
            } catch (err) {
                setIsLoading(false)
            }


            try {
                const resp = await axios.post(`https://api2.ip8.com/rdap/lookup`, { ip: [ip4] });
                if (resp?.data?.retcode === 201) {
                    const data = resp?.data?.result?.[ip4];
                    dispatch(set_entities(ip4, data));
                    dispatch(set_tabnames(ip4, 'mm'));
                }
            } catch (err) {

            }

        }
        setIsLoading(false);
        dispatch(set_ip_details(data, ipData, ip4, language, tab));
        setInfoMessage('')
    } catch (err) {

    }
}